import { DEFAULT_ADVANCED_SETTINGS } from '../../_components/AdvancedSettings/shared'
import { type BaseUIState, createPageStore } from '../../_shared/formStore'
import { COVER_DRAFT_STORAGE_KEY } from '../../_shared/formDraft/draftKeys'

import type { CoverFormValues } from '../_types/form'

// ─── Form 默认值 ───
export const COVER_FORM_DEFAULTS: CoverFormValues = {
  mode: 'smart',
  smartPrompt: '',
  customPrompt: '',
  instrumental: false,
  referenceAudio: null,
  style: '',
  advanced: DEFAULT_ADVANCED_SETTINGS,
}

// ─── Prefs：需要持久化的用户偏好 ───
export interface CoverPrefs {
  /** 高级设置面板展开状态 */
  advancedExpanded: boolean
}

const COVER_PREFS_DEFAULTS: CoverPrefs = {
  advancedExpanded: false,
}

// ─── UI：瞬态状态，不持久化 ───
export interface CoverUI extends BaseUIState {
  /** 歌词检测中 */
  isDetecting: boolean
}

const COVER_UI_DEFAULTS: CoverUI = {
  isSubmitting: false,
  isUploading: false,
  isDetecting: false,
}

// ─── Store 工厂 ───
export const createCoverStore = () =>
  createPageStore<CoverFormValues, CoverPrefs, CoverUI>({
    name: 'CoverStore',
    persistKey: COVER_DRAFT_STORAGE_KEY,
    formDefaults: COVER_FORM_DEFAULTS,
    prefsDefaults: COVER_PREFS_DEFAULTS,
    uiDefaults: COVER_UI_DEFAULTS,
    sanitizeOnLoad(data) {
      return {
        ...COVER_FORM_DEFAULTS,
        ...data,
        mode: data.mode || 'smart',
        referenceAudio: data.referenceAudio ?? null,
        advanced: {
          ...DEFAULT_ADVANCED_SETTINGS,
          ...data.advanced,
        },
      }
    },
  })
